import { useMatch } from 'react-router-dom'

const usePageMatch = () => {
  const isHomePage = useMatch('/home')
  const isIntroPage = useMatch('/intro')
  const isFaqPage = useMatch('/faq')
  const isCenterPage = useMatch('/center')
  const isNoticePage = useMatch('/notice')
  const isNoticeDetailPage = useMatch('/notice/detail/:idx')
  const isNewsPage = useMatch('/news')
  const isTermsPage = useMatch('/terms/:telecom/:termsIdx')
  const isCancelPage = useMatch('/cancel')
  const isRefundPage = useMatch('/refund')
  const isAskTermPage = useMatch('/ask')
  const matchNotFound = useMatch('*')

  return {
    isHomePage,
    isIntroPage,
    isFaqPage,
    isCenterPage,
    isNoticePage,
    isNoticeDetailPage,
    isNewsPage,
    isTermsPage,
    isCancelPage,
    isRefundPage,
    isAskTermPage,
    matchNotFound,
  }
}

export default usePageMatch
